import { render } from "./resonanceBetting.vue?vue&type=template&id=3782a5ce&scoped=true"
import script from "./resonanceBetting.vue?vue&type=script&lang=js"
export * from "./resonanceBetting.vue?vue&type=script&lang=js"

import "./resonanceBetting.vue?vue&type=style&index=0&id=3782a5ce&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3782a5ce"]])

export default __exports__